export interface ShipmentSubscriptionPayload {
    shipment_activity_notification: boolean;
    shipment_status_notification: boolean;
}

export interface ShipmentSubscriptionResponse extends ShipmentSubscriptionPayload {
    customer_user_id: string;
    shipment_id: string;
}
